// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const HistogramIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="HistogramIcon" ref={forwardedRef} {...props}>
      <path d="M4.5 3H3v13a1 1 0 0 0 1 1h12.994v-1.5H4.499v-1.767a4.49 4.49 0 0 0 3.904-3.148l1.41-4.563c.22-.711 1.23-.701 1.436.015l1.283 4.456a4.5 4.5 0 0 0 4.285 3.255l.17.002.013-1.5-.17-.002a3 3 0 0 1-2.857-2.17L12.69 5.622c-.618-2.148-3.65-2.178-4.31-.043l-1.41 4.563a2.99 2.99 0 0 1-2.47 2.083z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const HistogramIcon = /* @__PURE__ */ Object.assign(
  HistogramIconComponent,
  { displayName: 'HistogramIcon' },
);
